import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { computed, defineComponent } from "@vue/composition-api";
import { useApplicationVisibilityState } from "@Client/@Composables/application-standalone/machine/useApplicationVisibilityState";
import { useApplicationStandaloneStoreGetters } from "@Client/@Modules/application-standalone/store/application-standalone-helpers";
import * as ApplicationStandaloneGetters from "@Client/@Modules/application-standalone/store/application-standalone-getters";
import ApplicationNavbarLoader from "@Client/@Modules/application-standalone/components/loaders/application-navbar-loader.vue";
import NotificationPopover from "@Shared/components/general/notification-popover.vue";
import { ObserveVisibility } from "vue-observe-visibility";
export default defineComponent({
  name: "ApplicationNavbar",
  components: {
    ApplicationNavbarLoader,
    NotificationPopover
  },
  directives: {
    ObserveVisibility
  },
  props: {
    currentStep: {
      type: String,
      required: true
    },
    showMenuToggler: {
      type: Boolean,
      default: true
    },
    invalidSteps: {
      type: Array,
      default: () => []
    },
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      visibilityState
    } = useApplicationVisibilityState();
    const {
      LOADING
    } = useApplicationStandaloneStoreGetters([ApplicationStandaloneGetters.LOADING]);
    const progressPercentage = computed(() => {
      const index = currentStepIndex.value + 1;
      return 100 - index * 100 / visibilityState.value.length;
    });
    const currentStepIndex = computed(() => {
      var _context;
      return _findIndexInstanceProperty(_context = visibilityState.value).call(_context, tab => tab.name === props.currentStep);
    });
    const goNext = () => {
      emit("navigate-next");
    };
    const goPrev = () => {
      emit("navigate-back");
    };
    const goEdit = page => {
      emit("navigate-edit", page);
    };
    const isStepCompleted = (step, index) => {
      var _context2;
      return index < currentStepIndex.value && !_includesInstanceProperty(_context2 = props.invalidSteps).call(_context2, step);
    };
    const toggleSidebar = () => {
      emit("toggle-sidebar");
    };
    const handleCheckSidebarResponsive = isVisible => {
      if (isVisible && props.showSidebar) toggleSidebar();
    };
    return {
      tabs: visibilityState,
      progressPercentage,
      goPrev,
      goNext,
      goEdit,
      currentStepIndex,
      isStepCompleted,
      LOADING,
      toggleSidebar,
      handleCheckSidebarResponsive
    };
  }
});